export default __webpack_public_path__ + "static/media/01.def4b96a.png";